/**
 * Design System - Modern Corporate Style Variants
 * Clean, professional SaaS-style design tokens
 */

// Colori principali
export const colors = {
  primary: 'slate',      // #1E293B
  secondary: 'slate',    // #334155
  accent: 'blue',        // #3B82F6
  success: 'green',      // #22C55E
  danger: 'red',         // #EF4444
  warning: 'amber',      // #F59E0B
  info: 'blue',
};

// Dimensioni comuni
export const sizes = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
};

// Border radius - Modern Corporate: 12px globale
export const roundness = {
  sm: 'rounded-lg',
  md: 'rounded-xl',
  lg: 'rounded-xl',
  xl: 'rounded-2xl',
  full: 'rounded-full',
};

// Shadows - molto leggere
export const shadows = {
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg',
  xl: 'shadow-xl',
};

// Typography
export const typography = {
  title: 'text-4xl font-bold tracking-tight',
  heading: 'text-2xl font-bold tracking-tight',
  subheading: 'text-xl font-semibold tracking-tight',
  body: 'text-base font-normal',
  small: 'text-sm font-medium',
  tiny: 'text-xs font-medium',
  label: 'text-[11px] font-semibold uppercase tracking-wider text-slate-500',
};

// Varianti Button
export const buttonVariants = {
  primary: 'bg-blue-600 hover:bg-blue-700 text-white',
  secondary: 'bg-slate-100 hover:bg-slate-200 text-slate-700',
  success: 'bg-green-600 hover:bg-green-700 text-white',
  danger: 'bg-red-600 hover:bg-red-700 text-white',
  ghost: 'bg-transparent hover:bg-slate-100 text-slate-600',
  outline: 'bg-white border border-[#E2E8F0] hover:border-slate-300 text-slate-700',
};

export const buttonSizes = {
  xs: 'px-3 py-1.5 text-xs',
  sm: 'px-4 py-2 text-sm',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
  xl: 'px-8 py-4 text-lg',
};

// Varianti Input
export const inputVariants = {
  default: 'bg-white border border-[#E2E8F0] focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-slate-900',
  error: 'bg-white border border-red-300 focus:border-red-500 focus:ring-1 focus:ring-red-500 text-red-900',
  success: 'bg-white border border-green-300 focus:border-green-500 focus:ring-1 focus:ring-green-500 text-green-900',
};

export const inputSizes = {
  sm: 'p-2 text-sm',
  md: 'p-3 text-sm',
  lg: 'p-4 text-base',
};

// Varianti Card - bordo #E2E8F0, shadow leggera
export const cardVariants = {
  default: 'bg-white border border-[#E2E8F0] shadow-sm',
  elevated: 'bg-white border border-[#E2E8F0] shadow-md',
  flat: 'bg-[#F8FAFC]',
};

// Varianti Badge/Tag
export const badgeVariants = {
  primary: 'bg-blue-50 text-blue-700',
  secondary: 'bg-slate-100 text-slate-600',
  success: 'bg-green-50 text-green-700',
  danger: 'bg-red-50 text-red-700',
  warning: 'bg-amber-50 text-amber-700',
  info: 'bg-cyan-100 text-cyan-700',
};

// Varianti Table
export const tableVariants = {
  header: 'bg-[#F8FAFC] border-b border-[#E2E8F0]',
  row: 'hover:bg-[#F1F5F9] transition-colors duration-200',
  cell: 'px-5 py-4',
};

// Animazioni comuni
export const animations = {
  fadeIn: 'animate-in fade-in duration-200',
  slideIn: 'animate-in slide-in-from-top-2 duration-200',
  zoomIn: 'animate-in zoom-in duration-200',
  scaleClick: 'active:scale-[0.98] transition-all duration-200',
};

// Transizioni - 0.2s ease
export const transitions = {
  fast: 'transition-all duration-150 ease-in-out',
  normal: 'transition-all duration-200 ease-in-out',
  slow: 'transition-all duration-300 ease-in-out',
};

// Layout comuni
export const layouts = {
  container: 'max-w-7xl mx-auto px-4 md:px-6',
  section: 'py-8',
  card: 'p-5',
};

// Helper per combinare classi
export const cn = (...classes: (string | boolean | undefined | null)[]): string => {
  return classes.filter(Boolean).join(' ');
};
